<template>
	<span>
		<template v-if="orderDialog">
			<order-modal
				:order="newOrder"
				@closeDialog="closeDialog('orderDialog')"></order-modal>
		</template>
		<template v-if="purchaseOrderDialog">
			<order-modal
				:order="newPurchaseOrder"
				type="purchase-order"
				@closeDialog="closeDialog('purchaseOrderDialog')"></order-modal>
		</template>
	</span>
</template>

<script>
	import { helpers } from '../../store/helpers.js';
	import OrderModal from '../modals/Order';

    export default {
		components: {
			'order-modal' : OrderModal
		},
		computed: {
			orderDialog() {
				return this.$store.state.orderDialog;
			},
			purchaseOrderDialog() {
				return this.$store.state.purchaseOrderDialog;
			},
			orderDepartments() {
				return this.$store.getters.orderDepartments;
			},
			purchaseOrderDepartments() {
				return this.$store.getters.purchaseOrderDepartments;
			}
		},
		data() {
			return {
				newOrder: false,
				newPurchaseOrder: null
			}
		},
		methods: {
			closeDialog (dialog) {
				this.newOrder = false;
				this.$store.dispatch('set', {
					name: dialog,
					value: false
				});
			}
		},
		watch: {
			orderDialog(val) {
				if(val){
					let defaultOrder = {
						customer_id: '',
						date: null,
						fieldvalues: [],
						orderitems: [],
						configuration: {},
						assignment_type: 'order'
					}
					let order = helpers.setOrder({ order: defaultOrder, departments: this.orderDepartments, loadType: 'inital', fieldIds: this.$store.getters.fieldIds });
					this.newOrder = helpers.pushOrderValues(order, this.$store.getters.fieldIds);
				}
			},
			
			purchaseOrderDialog(val) {
				if(val){
					let defaultPurchaseOrder = {
						fieldvalues: [],
						orderitems: [],
						configuration: {},
						assignment_type: 'purchase-order'
					}
					let purchaseOrder = helpers.setOrder({ order: defaultPurchaseOrder, departments: this.purchaseOrderDepartments, loadType: 'inital', fieldIds: this.$store.getters.poFieldIds, type: 'purchase-order' });
					this.newPurchaseOrder = helpers.pushOrderValues(purchaseOrder, this.$store.getters.poFieldIds, 'purchase-order');
				}
			}
		}
    }
</script>
